<div *ngIf="phase && phase.name" class="d-flex" [attr.data-testid]="uid">
    <div class="d-flex align-items-center">
        <i aria-hidden="true" *ngIf="icon" [ngClass]="iconClass" aria-hidden="true"></i>
        {{ l('WorkItemProcess_' + phase.name) }}
    </div>
</div>
